module.exports = __webpack_public_path__ + "img/支付宝支付.b80ac7fc.png";